import React from 'react'

import { B, Container } from './styles'

export const TextCCB = (
  <Container>
    <p>
      <B>IV. DECLARAÇÕES:</B>
    </p>
    <p>
      <B>O EMITENTE DECLARA QUE:</B>
    </p>
    <table>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>a)</td>
        <td style={{ fontWeight: 'bold' }}>
          PREVIAMENTE À EMISSÃO DESTA CÉDULA DE CRÉDITO BANCÁRIO (“CCB”), TOMOU CIÊNCIA E ANUIU
          QUANTO À PROPOSTA DE CRÉDITO, QUE CONTÉM TAXA DE JUROS, VALOR SOLICITADO, IOF, TARIFA DE
          CADASTRO E SEGURO PRESTAMISTA (SE CONTRATADO), ELEMENTOS QUE COMPÕEM O CUSTO EFETIVO TOTAL
          (“CET”) DO FINANCIAMENTO/CRÉDITO. O CÁLCULO DO CET, COMO DEMONSTRADO, TOMOU EM
          CONSIDERAÇÃO A LIBERAÇÃO DO CRÉDITO E O FLUXO DOS PAGAMENTOS PREVISTOS, INCLUINDO A TAXA
          ANUAL E EFETIVA DE JUROS, TRIBUTOS, TARIFAS E DESPESAS.
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>b)</td>
        <td style={{ fontWeight: 'bold' }}>
          TEM CIÊNCIA QUE A LIBERAÇÃO DO EMPRÉSTIMO DEPENDE DA AVERBAÇÃO EM FOLHA DE PAGAMENTO JUNTO
          AO EMPREGADOR DO EMITENTE E PODERÁ ACONTECER EM ATÉ 5 (CINCO) DIAS.
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>c)</td>
        <td style={{ fontWeight: 'bold' }}>
          SE FOR O CASO, COMO ACORDADO COM O CREDOR, CONCORDA QUE OS RECURSOS DESTE EMPRÉSTIMO SERÃO
          INTEGRALMENTE DESTINADOS À QUITAÇÃO DE DÍVIDA PREEXISTENTE, DE MAIOR CUSTO FINANCEIRO,
          MANTIDA JUNTO AO CREDOR.
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>d) </td>
        <td style={{ fontWeight: 'bold' }}>
          ESTÁ CIENTE E DE ACORDO QUE ESTE EMPRÉSTIMO VISA A SUA REESTRUTURAÇÃO FINANCEIRA MEDIANTE
          SUBSTITUIÇÃO DE DÍVIDA DE MAIOR CUSTO FINANCEIRO POR UM CRÉDITO COM CONDIÇÕES MAIS
          FAVORÁVEIS, CONFORME DIRETRIZES DA MP 1.292/2025.
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>e) </td>
        <td style={{ fontWeight: 'bold' }}>
          ESTÁ CIENTE E DE ACORDO QUE O EMPRÉSTIMO PODERÁ SER CANCELADO E ESTA CCB SERÁ CONSIDERADA
          NULA DE PLENO DIREITO, AUTOMATICAMENTE ANTES DA LIBERAÇÃO DO CRÉDITO AO EMITENTE SE:
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }} />
        <td style={{ marginLeft: 100, fontWeight: 'bold' }}>
          <p>(I) O EMITENTE NÃO POSSUIR MARGEM CONSIGNÁVEL DISPONÍVEL;</p>
          <p>(II) NÃO FOR CONFIRMADA A AVERBAÇÃO;</p>
          <p>(III) O EMPREGADOR SE RECUSAR A EFETIVAR O EMPRÉSTIMO EM NOME DO EMITENTE;</p>
          <p>(IV) OCORRER QUALQUER FALHA OU FRAUDE NA AUTENTICAÇÃO DO APLICATIVO;</p>
          <p>
            (V) OS DADOS PARA DESEMBOLSO ESTIVEREM INCORRETOS, OU OCORRER QUALQUER PROBLEMA COM A
            CONTA INDICADA NO PREÂMBULO QUE IMPEÇA O CRÉDITO OU TRANSFERÊNCIA;
          </p>
          <p>
            (VI) FOR APURADO QUALQUER IMPEDIMENTO DE NATUREZA REGULATÓRIA OU LEGAL QUE SEJA
            CONSIDERADA IMPEDITIVA DA CONTRATAÇÃO PELO CREDOR; OU
          </p>
          <p>(VII) NÃO HOUVER APROVAÇÃO DO CRÉDITO PELO CREDOR.</p>
        </td>
      </tr>
    </table>
    <p>
      <B>V. DEFINIÇÕES:</B>
    </p>
    <table>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>a)</td>
        <td>
          <strong>CRÉDITO CONSIGNADO PRIVADO:</strong> o empréstimo indicado nesta CCB é concedido
          na modalidade crédito consignado descontado em folha de pagamento, de acordo com a Lei nº
          10.820/2003, alterada pela Medida Provisória nº 1.292/2025 (“Lei 10.820/2003”), destinado
          a empregados regidos pela Consolidação das Leis do Trabalho – CLT, a trabalhadores regidos
          pela Lei nº 5.889/1973, e pela Lei Complementar nº 150/2015, de diretores não empregados
          com direito ao Fundo de Garantia do Tempo de Serviço – FGTS.
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>b)</td>
        <td>
          <strong>IOF:</strong> Imposto sobre Operações de Crédito, Câmbio e Seguro, ou relativas a
          Títulos ou Valores Mobiliários, cobrado nas operações de crédito, nos termos da Lei 5.143,
          de 20/10/1966, e do Decreto 6.306, de 14/12/2007.
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>c)</td>
        <td>
          <strong>LIBERAÇÃO DO CRÉDITO:</strong> significa o depósito na conta do EMITENTE; caso a
          conta do EMITENTE seja mantida em outra instituição financeira, que será efetuado por
          transferência eletrônica disponível – TED, ficando sujeita aos prazos e regulamentos do
          Banco Central do Brasil.
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>d)</td>
        <td>
          <strong>VALOR DO MÚTUO:</strong> significa o valor solicitado pelo EMITENTE para o
          empréstimo e que será depositado na conta corrente de sua titularidade, indicada acima.
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>e)</td>
        <td>
          <strong>VALOR DO MÚTUO FINANCIADO:</strong> significa o valor total do crédito concedido
          pelo CREDOR, que inclui o Valor do Mútuo (que será depositado em sua conta) somado a: (i)
          IOF, (ii) Tarifas, (iii) Seguro, se contratado, e (iv) outras despesas previstas nesta
          CCB;
        </td>
      </tr>
      <tr>
        <td style={{ display: 'flex', alignItems: 'top', fontWeight: 'bold' }}>f)</td>
        <td>
          <strong>VALOR DO MÚTUO TOTAL:</strong> significa a soma de todas as parcelas de pagamento
          do empréstimo, que inclui o VALOR DO MÚTUO FINANCIADO e o juros cobrados pelo CREDOR.
        </td>
      </tr>
    </table>

    <p>
      <B>VI. CLÁUSULAS E CONDIÇÕES:</B>
    </p>
    <p>
      <B>1.</B> O <B>Valor do Mútuo</B> será disponibilizado diretamente pelo <B>CREDOR</B> na conta
      de titularidade do <B>EMITENTE</B>, indicada no item I. acima, ou de outra forma, se o crédito
      se destinar a refinanciamento ou decorrente de portabilidade, hipóteses em que os recursos
      serão utilizados para liquidação das operações de crédito originais, nos termos da
      regulamentação do Conselho Monetário Nacional (“CMN”) ou do Banco Central do Brasil (“BCB”),
      conforme ajustado entre <B>CREDOR</B> e <B>EMITENTE</B>.
    </p>
    <p>
      <B>
        1.1 O EMITENTE declara que, na hipótese de existência de operações de crédito ativas sem
        garantias, com desconto ou não em folha de pagamento na presente data, os recursos dessa
        contratação serão utilizados para a liquidação das operações de crédito contratadas junto ao
        CREDOR ou em outra instituição financeira, ou amortização parcial, na hipótese de o Valor do
        Mútuo não ser suficiente para liquidação integral das operações de crédito em aberto. Caso o
        Valor do Mútuo seja superior ao valor das operações de crédito em aberto, o saldo
        remanescente, se houver, será creditado na conta do EMITENTE indicada no item I. acima.
      </B>
    </p>
    <p>
      <B>
        2. Fica assegurado ao EMITENTE o direito de desistência da presente contratação, em até 7
        (sete) dias a contar da data de recebimento dos recursos pelo EMITENTE, nos termos do Art.
        49, da Lei nº 8.078/1990 (Código de Defesa do Consumidor), devendo o EMITENTE comunicar o
        CREDOR sobre a sua decisão e devolver imediatamente a totalidade do valor desembolsado.
      </B>
    </p>
    <p>
      <B>
        2.1. Após a comunicação do EMITENTE, no prazo acima, e devolução total dos valores
        desembolsados, o CREDOR providenciará o cancelamento da operação de crédito e sua exclusão
        da consignação em folha de pagamento.
      </B>
    </p>
    <p>
      <B>3.</B> O <B>Mútuo Financiado</B> deverá ser pago pelo <B>EMITENTE</B> ao <B>CREDOR</B>,
      acrescido de juros remuneratórios capitalizados mensalmente, nos termos da MP 2170-36/2001, à
      taxa estipulada no preâmbulo, que será convertida em uma taxa diária, considerando um mês de
      30 dias.
    </p>
    <p>
      <B>3.1.</B> O pagamento do <B>Mútuo Financiado</B> será feito por meio de consignação em folha
      de pagamentos, na quantidade de parcelas, valores e datas de vencimento indicados no
      preâmbulo, bem como IOF, Tarifas e o Seguro, se for o caso, que se encontram incorporados às
      parcelas ajustadas.
    </p>
    <p>
      <B>4.</B> O atraso no pagamento de qualquer das parcelas previstas nesta <B>CCB</B> ou a não
      efetivação de qualquer amortização do saldo devedor importarão no vencimento antecipado das
      obrigações desta <B>CCB</B>, de pleno direito, tornando-se imediatamente exigíveis todas as
      parcelas em aberto e os demais encargos ou o saldo devedor com seus acessórios, a ser apurado
      nos termos das cláusulas da presente <B>CCB</B>, tudo isso independentemente de qualquer
      aviso, notificação ou interpelação judicial ou extrajudicial. Ademais, poderá o <B>CREDOR</B>{' '}
      considerar antecipadamente vencida a presente <B>CCB</B> se configurada a ocorrência das
      hipóteses previstas no Art. 1.425 do Código Civil.
    </p>
    <p>
      <B>5.</B> Em caso de mora relativa a quaisquer das obrigações estipuladas nesta <B>CCB</B>,
      bem como em todas as hipóteses de vencimento antecipado, incidirão sobre o saldo devedor do{' '}
      <B>Mútuo Financiado</B>, da data da ocorrência do vencimento das obrigações até o dia do
      efetivo pagamento da integralidade do débito, juros remuneratórios nos moldes convencionados,
      juros de mora de 1% (um por cento) ao mês e multa de 2% (dois por cento) sobre a dívida.
    </p>
    <p>
      <B>
        6. Caso ocorra mora e/ou inadimplemento no cumprimento de qualquer das obrigações previstas
        nesta CCB, bem como caso se verifique alguma das hipóteses de vencimento antecipado, estará
        o CREDOR, de pleno direito, autorizado pelo EMITENTE a registrar o nome deste nos cadastros
        de proteção ao crédito e registro de inadimplência (tais como o SERASA, SPC, CDL e outros),
        bem como na Central de Riscos do Banco Central do Brasil (“BACEN”). O EMITENTE declara que
        concorda e está ciente de que o atraso ou a inadimplência das obrigações previstas nesta CCB
        dará ao CREDOR, de pleno direito, a prerrogativa de determinar o protesto desta CCB.
      </B>
    </p>
    <p>
      <B>
        7. Vencida a dívida, ou na ocorrência de vencimento antecipado, o EMITENTE autoriza, desde
        já, o CREDOR, em caráter irrevogável e irretratável, a promover a compensação da dívida
        contraída, nos termos desta CCB, com eventuais créditos que tenha ou venha a ter junto ao
        CREDOR ou a instituições conveniadas, inclusive créditos em conta corrente e aplicações
        financeiras, bem como aqueles decorrentes de excesso de garantias de outros ajustes firmados
        com o CREDOR, conferindo a este, neste ato, os necessários poderes para proceder ao resgate
        ou negociação de títulos, em valor suficiente para a liquidação do saldo devedor da dívida
        existente. Nesta hipótese, o EMITENTE autoriza o CREDOR a debitar os valores devidos,
        inclusive valores parciais, de sua conta corrente mantida perante o CREDOR.
      </B>
    </p>
    <p>
      <B>8.</B> O <B>EMITENTE</B> reconhece que a presente <B>CCB</B> representa título líquido,
      certo e exigível pelo valor do saldo apurado em conformidade com suas cláusulas e condições,
      reconhecendo ainda a força executiva da presente <B>CCB</B>, seja pelo seu próprio teor seja
      pela sua integração, obtida por meio de planilhas elaboradas pelo <B>CREDOR</B> e que
      demonstrem os lançamentos de débitos computados e a atualização do saldo devedor segundo os
      critérios convencionados.
    </p>
    <p>
      <B>9.</B> O <B>CREDOR</B> poderá endossar, ceder, vender, transferir ou entregar em penhor
      todos os direitos e garantias decorrentes da presente <B>CCB</B>, sub-rogando-se o(s)
      cessionário(s) em todos os direitos, interesses, prerrogativas e garantias decorrentes do
      endosso, cessão, venda, transferência ou penhor, sem que haja necessidade de autorização
      prévia do <B>EMITENTE</B>.
    </p>
    <p>
      <B>
        10. O EMITENTE autoriza, de forma expressa e na forma da lei, seu empregador, em caráter
        irrevogável e irretratável, a promover os descontos/débitos, mediante consignação na folha
        de pagamento de sua matrícula funcional, das prestações mensais e sucessivas, em quantidade
        e valor indicados no preâmbulo. Os descontos perdurarão até a integral liquidação do saldo
        devedor de responsabilidade do EMITENTE em favor do CREDOR.
      </B>
    </p>
    <p>
      <B>
        10.1. O EMITENTE responsabiliza-se por cumprir, até a data estipulada para o vencimento, as
        obrigações derivadas desta CCB nas seguintes hipóteses: (a) se ocorrer perda da margem
        consignável, por quaisquer motivos que impossibilitem o pagamento do valor total ou parcial
        das parcelas desta CCB por meio de consignação na folha de pagamento; ou (b) quando, por
        falha operacional da empregador responsável ou do CREDOR, o valor/benefício/remuneração for
        creditado ao EMITENTE sem que ocorra a retenção do valor referente à parcela, conforme
        previsto nesta CCB.
      </B>
    </p>
    <p>
      <B>
        10.2. Nos casos de rescisão ou suspensão do vínculo empregatício do EMITENTE, nos termos da
        Lei nº 10.820/2003 e alterações, o desconto das parcelas e das garantias será redirecionado
        automaticamente para: (i) outros vínculos empregatícios ativos do EMITENTE; ou (ii) vínculos
        empregatícios do EMITENTE que surjam posteriormente.
      </B>
    </p>
    <p>
      <B>
        10.3. Nos casos de redução da renda do EMITENTE, durante a vigência desta CCB, o EMITENTE
        obriga-se a procurar o CREDOR para repactuação das condições de pagamento, de forma a
        ajustá-las às novas condições de remuneração.
      </B>
    </p>
    <p>
      <B>
        10.4. Na hipótese de redução da margem consignável, por mera liberalidade, o CREDOR poderá
        manter o desconto em folha de pagamento das parcelas pactuadas de forma parcial.
      </B>
    </p>
    <p>
      <B>
        11. Caso se verifique qualquer das situações listadas na Cláusula 10, o EMITENTE autoriza o
        CREDOR, desde já, em caráter irrevogável e irretratável, a proceder com o débito total ou
        parcial das parcelas devidas na sua conta corrente mantida perante o CREDOR.
      </B>
    </p>
    <p>
      <B>
        11.1. No caso de impossibilidade do débito na conta corrente, a cobrança poderá ser feita
        por meio de boleto bancário, hipótese em que o EMITENTE, agindo com base na boa-fé prevista
        no artigo 4º, inciso III, da Lei nº 8.078/90, se obriga a, de imediato, contatar o CREDOR
        solicitando a emissão do boleto bancário para efetuar o pagamento.
      </B>
    </p>
    <p>
      <B>12.</B> Caso, por qualquer motivo, ocorra atraso na averbação junto ao órgão empregador do{' '}
      <B>EMITENTE</B>, dos descontos das parcelas originalmente pactuadas, fica, desde já,
      autorizado o <B>CREDOR</B> a promover a prorrogação das parcelas, adequando-as ao novo fluxo
      de descontos, sem, contudo, ocorrer qualquer alteração em sua quantidade e valores, evitando
      assim, qualquer acréscimo suplementar ao <B>EMITENTE</B>.
    </p>
    <p>
      <B>13.</B> Fica explicitado que a não efetivação do débito previsto na Cláusula 11, ainda que
      haja saldo bastante, ou sua efetivação parcial, não tirará a certeza, a liquidez e a
      exigibilidade da dívida, não impedindo, por consequência, que o <B>CREDOR</B> promova a
      execução ou qualquer medida judicial contra o <B>EMITENTE</B>, o que se fará independentemente
      de formalidade de qualquer natureza, especialmente aviso e notificação.
    </p>
    <p>
      <B>
        14. Por meio desta CCB, o EMITENTE autoriza o CREDOR, a qualquer tempo, a teor do disposto
        na Resolução CMN nº 5.037 de 29 de setembro de 2022, a: (i) consultar todos os seus dados e
        informações, constantes do Sistema de Informações de Crédito `SCR`, gerenciado pelo BACEN e
        dos sistemas que venham a complementá-lo e/ ou a substituí-lo, a qualquer tempo, inclusive
        quando, da elaboração e/ou atualização de seu cadastro, análise de limite ou contratação de
        operações de crédito, e mesmo após a rescisão do presente instrumento; e (ii) fornecer ao
        BACEN, por meio do registro no SCR, sem que isso implique na violação de sigilo bancário, os
        dados e as informações relacionadas às dívidas (a vencer e/ou vencidas), montante dos
        débitos, operações de crédito contratadas, coobrigações e responsabilidades por garantias
        contraídas.
      </B>
    </p>
    <p>
      <B>
        14.1. O SCR é um sistema que tem por finalidade prover ao BACEN informações para
        monitoramento de informações do sistema financeiro e fiscalização, bem como propiciar o
        intercâmbio entre as instituições financeiras de operações e responsabilidades.
      </B>
    </p>
    <p>
      <B>
        14.2. O EMITENTE está ciente que: (i) poderá ter acesso aos seus dados registrados no SCR,
        por meio dos canais disponibilizados pelo BACEN e, (ii) em caso de divergência dos dados
        registrados no SCR, poderá solicitar, por meio da central de atendimento do CREDOR, mediante
        requerimento escrito e fundamentado, a correção, exclusão ou registro de manifestação de
        discordância, além do cadastramento de medidas judiciais.
      </B>
    </p>
    <p>
      <B>15.</B> O <B>CREDOR</B> tratará os dados pessoais (conforme definido na LGPD) recebidos
      neste ato e/ou coletados em razão desta <B>CCB</B> somente para executar as obrigações
      contratuais aqui descritas, respeitando os limites e em razão das finalidades dispostas nesta{' '}
      <B>CCB</B> , e para atender obrigações legais e/ou regulatórias conforme a Lei nº 13.709/18
      (“LGPD”). O <B>CREDOR</B> declara (i) adotar medidas técnicas e administrativas aptas a
      proteger os dados pessoais de tratamentos acidentais ou ilícitos; (ii) exercer os melhores
      esforços para manter os dados pessoais atualizados; (iii) compartilhar os dados pessoais com
      terceiros apenas quando necessário à execução desta <B>CCB</B> ; e (iv) garantir aos dados
      pessoais, que sejam eventualmente transferidos internacionalmente, um nível de proteção
      compatível com ao da LGPD.
    </p>
    <p>
      <B>15.1.</B> Os dados pessoais serão coletados, tratados e compartilhados pelo CREDOR nos
      termos de sua Política de Privacidade disponível para consulta, a qualquer tempo, por meio do
      site
      <a href="https://inter.co/politica-de-privacidade/" target="_blank" rel="noreferrer">
        https://inter.co/politica-de-privacidade/
      </a>
      . Ainda, o CREDOR esclarecerá dúvidas relacionadas à privacidade pelo telefone 3003-4070
      (capitais e regiões metropolitanas) e 0800 940 0007 (para demais localidades) ou pelo e-mail{' '}
      <a href="mailto:privacidade@inter.co">privacidade@inter.co</a>.
    </p>
    <p>
      <B>15.2.</B> O <B>EMITENTE</B> reconhece que os tratamentos realizados no âmbito desta{' '}
      <B>CCB</B> restringem-se aos dados colhidos em razão deste instrumento e independem de
      tratamento realizado como decorrência de outra relação de natureza comercial, contratual ou
      pessoal existente entre o <B>CREDOR</B> e o <B>EMITENTE</B> e, de nenhuma forma limita,
      restringe, anula ou impede esse último tratamento.
    </p>
    <p>
      <B>16.</B> O <B>EMITENTE</B> declara e garante que deseja receber publicidades, publicações e
      campanhas de marketing do <B>CREDOR</B>, reconhecendo que, a qualquer momento, poderá alterar
      suas preferências de marketing por meio da Central de Privacidade Inter ou pelos canais de
      atendimento.
    </p>
    <p>
      <B>17.</B> O <B>EMITENTE</B> declara-se ciente de que os dados cadastrais por ele fornecidos
      para a realização do empréstimo servirão de base para confecção de seu cadastro.
    </p>
    <p>
      <B>17.1.</B> O <B>EMITENTE</B> autoriza expressamente o <B>CREDOR</B> a informar os dados
      relativos a todas as obrigações assumidas, nos termos desta <B>CCB</B>, para que constem nos
      cadastros compartilhados pelo <B>CREDOR</B> com outras instituições conveniadas, administradas
      pelo SERASA, SPC, CDL ou por outras entidades de proteção ao crédito.
    </p>
    <p>
      <B>
        17.2. O EMITENTE obriga-se a informar prontamente ao CREDOR toda e qualquer alteração de
        seus dados cadastrais, especialmente endereço, telefone, e-mail, renda e patrimônio.
      </B>
    </p>
    <p>
      <B>
        18. Fica assegurado ao EMITENTE o direito de liquidar antecipadamente o débito contraído
        junto ao CREDOR, nos termos da Lei nº 8.078/90, observadas as alterações dadas pela Lei nº
        14.181/21.
      </B>
    </p>
    <p>
      <B>
        18.1. Se a liquidação antecipada acarretar a ocorrência de parcelas em trânsito (parcelas
        descontadas pelo órgão consignante simultaneamente à liquidação do contrato), o EMITENTE
        autoriza desde já o CREDOR a compensá-las com eventuais parcelas em aberto, mesmo que não
        vencidas, na hipótese da existência de contrato(s) ainda não quitado(s), como forma de
        amortização do valor da dívida. Caso o EMITENTE não possua mais qualquer dívida em aberto
        junto ao CREDOR, as referidas parcelas serão reembolsadas.
      </B>
    </p>
    <p>
      <B>18.2.</B> O <B>CREDOR</B> obriga-se disponibilizar a planilha de cálculo para liquidação
      antecipada da operação de crédito, por solicitação do devedor.
    </p>
    <p>
      <B>19.</B> O <B>CREDOR</B> obriga-se a disponibilizar a planilha de cálculo para a
      transferência da operação de crédito da instituição credora original para a instituição
      proponente, por solicitação do devedor.
    </p>
    <p>
      <B>
        20. Nos termos da Lei nº 10.820/2003, o EMITENTE oferece em garantia a esta CCB, desde já e
        de forma irrevogável e irretratável, (i) até 10% (dez por cento) do saldo de sua conta
        vinculada no Fundo de Garantia do Tempo de Serviço – FGTS; e/ou (ii) até 100% (cem por
        cento) do da multa paga pelo EMPREGADOR, em caso de despedida sem justa causa ou de
        despedida por culpa recíproca ou força maior.
      </B>
    </p>
    <p>
      <B>
        20.1. Tendo optado por oferecer o FGTS como garantia da presente operação, o EMITENTE
        declara que está ciente, concorda e autoriza, de forma irrevogável e irretratável, a
        utilização dos recursos provenientes do saque da sua conta vinculada ao FGTS, incluindo a
        integralidade do valor da multa de sua rescisão do contrato de trabalho, para pagamento
        total ou parcial do saldo devedor, nos limites e condições estabelecidos na legislação e
        regulamentação vigentes.
      </B>
    </p>
    <p>
      <B>
        21. Verificada a hipótese da cláusula 20 acima, o EMITENTE outorga a CREDOR poderes de
        representação junto à Caixa Econômica Federal, para praticar todos os atos necessários à
        utilização dos recursos provenientes ao saque da conta vinculada do FGTS para pagamento
        integral ou parcial do saldo devedor.
      </B>
    </p>
    <p>
      <B>
        22. Nas operações com garantia do FGTS, se, por qualquer motivo, o saldo vinculado ao FGTS
        do EMITENTE for insuficiente ou não puder ser utilizado para quitação e/ou amortização do
        saldo devedor, o EMITENTE deverá efetuar o pagamento das parcelas em aberto diretamente ao
        CREDOR, por meio de débito em conta (autorizado desde já), ou por meio de boleto bancário,
        sob pena de incorrer nos encargos moratórios e demais sanções previstas no presente
        contrato.
      </B>
    </p>
    <p>
      <B>
        23. Quando aplicável, e nas hipóteses de rescisão do contrato de trabalho, o EMITENTE está
        ciente e concorda de que haverá o desconto do saldo devedor nas verbas rescisórias até o
        limite de 35% (trinta e cinco por cento).
      </B>
    </p>
    <p>
      <B>
        24. Nas hipóteses de rescisão, superada a Cláusula 23, poderá ser utilizado todos os
        vínculos empregatícios ativos no momento da contratação do crédito que se fizerem
        necessários ao adimplemento das obrigações assumidas, e será autorizado, em caso de rescisão
        ou de suspensão do contrato de trabalho, o seu redirecionamento para outros vínculos
        existentes no e-social, conforme Art. 1º, § 9º, da Lei 10.820/2003.
      </B>
    </p>
    <p>
      <B>25.</B> Eventuais tolerâncias do <B>CREDOR</B> com relação ao não cumprimento ou mora no
      cumprimento das obrigações e dos prazos desta <B>CCB</B> não importarão em novação ou
      desistência, não podendo ser invocadas, sob hipótese alguma, pelo <B>EMITENTE</B>, ficando
      assegurado ao <B>CREDOR</B>, todos os seus direitos.
    </p>
    <p>
      <B>26.</B> Caso haja a contratação de seguro e este seja custeado pelo <B>EMITENTE</B>, a
      depender do indicado no item III.18, o <B>EMITENTE</B> concorda que a(s) parcela(s)
      respectiva(s) poderá(ão) ser financiada(s) e que o pagamento do montante relativo ao prêmio
      respectivo servirá para garantir a quitação do saldo devedor parcial ou total do contrato
      assumido junto ao estipulante e beneficiário do seguro.
    </p>
    <p>
      <B>26.1.</B> Decorrido o prazo de 90 (noventa) dias do vencimento sem pagamento, o seguro
      ficará automaticamente e de pleno direito cancelado, independentemente de interpelação
      judicial ou extrajudicial, sem que caiba restituição de qualquer parcela do prêmio paga.
    </p>
    <p>
      <B>26.2</B> No caso da ocorrência de sinistro durante o período de 90 (noventa) dias de atraso
      no pagamento do prêmio, a indenização, quando devida, será paga, nos termos das condições
      contratuais/regulamento do seguro, desde que os prêmios em atraso sejam previamente pagos,
      acrescidos de juros legais e atualização monetária.
    </p>
    <p>
      <B>26.3.</B> O <B>EMITENTE</B> declara estar ciente de que, caso seja de seu interesse, poderá
      contratar o seguro com a seguradora de sua preferência, vinculando-o à presente operação de
      crédito. Para tanto deverá se informar sobre os procedimentos e a documentação necessária
      junto à seguradora escolhida.
    </p>
    <p>
      <B>27.</B> O <B>EMITENTE</B> reconhece a validade da assinatura eletrônica, ainda que não
      ligada à ICP-Brasil, podendo o serviço de assinatura ser prestado por qualquer terceiro cujo
      objeto seja a prestação desse tipo de serviço. A assinatura eletrônica passa a ser admitida em
      todos os documentos que envolvam as partes, seja na qualidade de partes, intervenientes, ou
      como terceiros a quem o documento venha a ser oposto, de maneira que os documentos assim
      assinados constituem documentos eletrônicos para os fins do artigo 10, caput e parágrafo
      segundo, da MP 2.200-2/01 e Art. 889, §3º do Código Civil, estando cientes de que esta forma
      de assinatura não desnatura o presente título de crédito, bem como não o descaracteriza como
      tal, inclusive no que concerne à cartularidade, na medida em que emitida por escrito e
      assinada pelas partes, e viável seu protesto por indicação.
    </p>
    <p>
      <B>28.</B> A presente <B>CCB</B> é digital e disponibilizada em vias iguais.
    </p>
    <p>
      <B>
        29. O EMITENTE declara, ao assinar esta CCB, que: (a) compreendeu integralmente o
        significado e conteúdo da presente CCB; (b) o presente negócio se adequa plenamente às suas
        necessidades, interesses e objetivos; (c) o pagamento das parcelas deste empréstimo é
        compatível com sua responsabilidade de honrar com todos os compromissos financeiros,
        realizar a manutenção de seus gastos pessoais, e não compromete os valores necessários para
        garantir seu mínimo existencial; (d) o CREDOR prestou-lhes todas as informações necessárias
        para a(s) sua(s) livre escolha e tomada(s) de decisões, explicitando, inclusive, os seus
        direitos, deveres, responsabilidades, custos ou ônus, penalidades e riscos existentes na
        execução das operações; (e) as informações prestadas são verdadeiras e autênticas e que se
        compromete a, sempre que houver alterações em seus dados cadastrais, informar ao CREDOR a
        respeito; (f) tem ciência de que é possível realizar a transferência de operação de crédito
        da instituição credora original para a instituição proponente, por solicitação do devedor;
        (g) se aplicável, a depender do tipo de convênio celebrado, o EMITENTE autoriza o
        empregador/ averbador/conveniado a consultar e/ou auditar, a qualquer tempo, os contratos ou
        documentos que geraram os descontos, a exemplo da presente CCB; (h) está ciente de que, nas
        contratações realizadas por dispositivos moveis de comunicação (mobile), caixas eletrônicos
        (ATM), internet ou qualquer outro meio permitido por Lei (desde que fora do estabelecimento
        comercial), poderá desistir do contrato no prazo de até 7 (sete) dias a contar do
        recebimento do crédito, devendo restituir o valor total concedido que lhe foi entregue,
        acrescido de eventuais tributos incidentes sobre a operação; e (i) nos casos em que há a
        contratação de seguro e este é custeado pelo EMITENTE, que foi informado e tem ciência do
        percentual de comissão paga ao corretor pela intermediação do contrato, na hipótese da
        contratação do seguro (CNSP Nº 382/20).
      </B>
    </p>
    <p>
      Por estarem de pleno acordo quanto às condições acima avençadas, o <B>EMITENTE</B> e o{' '}
      <B>CREDOR</B> confirmam as condições e as obrigações previstas nesta <B>CCB</B> lançada pelo{' '}
      <B>EMITENTE</B>, na data prevista (item III.12), e em 2 (duas) vias, sendo a via do{' '}
      <B>CREDOR</B> a única negociável, ao tempo em que ratificam a opção pelo foro de Belo
      Horizonte - MG, eleito competente para a solução judicial de qualquer controvérsia decorrente
      desta <B>CCB</B>.
    </p>
    <p>
      <B>
        DECLARAÇÃO DE RECEBIMENTO DA CCB: O EMITENTE declara ter recebido uma via original desta CCB
        nos exatos termos da Proposta de Crédito, da qual declara previa ciência e aceitação.
        Ademais, o EMITENTE declara estar ciente e de acordo com as condições descritas nesta CCB.
        Declara ainda conhecer os canais de atendimento do CREDOR constantes nesta CCB, por meio dos
        quais poderá pedir cópia de documentos, saldo devedor ou outros serviços. O CREDOR não cobra
        e não autoriza que cobrem em seu nome nenhum valor pela intermediação e/ou liberação do
        empréstimo pleiteado pelo EMITENTE. A proposta válida por 2 (dois) dias a partir da data de
        envio do documento. Em caso de dúvida, acesse o chat do Inter por meio do endereço
        eletrônico https://ajuda.bancointer.com.br/pt-BR e clique na janela localizada no canto
        inferior direito para iniciar a conversa.
      </B>
    </p>
  </Container>
)
